import React from 'react';
import { useHelpArticle } from '@retail/sanity/data-access';
import { TanstackQueryLoadingWrapper } from '@shared/components';
import { useSanityLanguageCode } from '@retail/sanity/hooks';
import { HelpArticle } from '@retail/help-center/components';

interface Props {
  slug: string;
}

export const HelpArticleContainer: React.FC<Props> = ({ slug }) => {
  const language = useSanityLanguageCode();
  const loadingstate = useHelpArticle({
    language,
    slug,
  });

  return (
    // @ts-ignore
    <TanstackQueryLoadingWrapper loadingState={loadingstate}>
      {(article) => <HelpArticle title={article.title} content={article.content} />}
    </TanstackQueryLoadingWrapper>
  );
};
